export default __webpack_public_path__ + "static/media/stopstalk.151f880e.png";